import Snackbar from 'components/@extended/Snackbar'
import { ProtectedRoute } from 'components/ProtectedRoute'
import SubscriptionFeatureRoute from 'components/SubscriptionFeatureRoute'

// project import

import Notistack from 'components/third-party/Notistack'
import { useGlobalState } from 'contexts/GlobalStateContext'

import useAuth from 'hooks/useAuth'
import { useEffect } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import LoginRoutes from 'routes/LoginRoutes'
import MainRoutes from 'routes/MainRoutes'
import PasswordChangeGuard from 'utils/route-guard/PasswordChangeGuard'

function App() {
  const { profile, isLoading } = useAuth()
  const { onChangeOrganizationSelection } = useGlobalState()

  useEffect(() => {
    const getUser = async () => {
      if (!isLoading && profile && profile.roles && profile.roles.length > 0) {
        onChangeOrganizationSelection(profile.roles[0].organization || null)
      }
    }

    getUser()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile, isLoading])

  const renderRoutes = (routes: typeof LoginRoutes | typeof MainRoutes, isProtectedParent: boolean = false) =>
    routes.children.map((route) => {
      // Check if any child route is protected to determine if parent layout needs protection
      const hasProtectedChildren = route.children?.some((child) => child.protected)
      const shouldProtectParent = isProtectedParent || hasProtectedChildren

      return (
        <Route
          key={route.path}
          path={route.path}
          element={shouldProtectParent ? <ProtectedRoute>{route.element}</ProtectedRoute> : route.element}
        >
          {route.children?.map((child: any) => {
            // Wrap element with SubscriptionFeatureRoute if subscriptionTierFeature is specified
            let element = child.element
            if (child.subscriptionTierFeature) {
              element = (
                <SubscriptionFeatureRoute requiredFeatures={child.subscriptionTierFeature}>
                  {child.element}
                </SubscriptionFeatureRoute>
              )
            }

            return <Route key={child.path} path={child.path} element={element} />
          })}
        </Route>
      )
    })

  return (
    <>
      <Notistack>
        <PasswordChangeGuard>
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            {renderRoutes(LoginRoutes)}
            {renderRoutes(MainRoutes)}
          </Routes>
        </PasswordChangeGuard>
        <Snackbar />
      </Notistack>
    </>
  )
}

export default App
